// External libraries
import React from 'react';

// Internal modules
import { Email } from '../Email';
import { Name } from '../Name';
import { PhoneNumber } from '../Phone';
import { shouldRenderFields } from './utils';
import { features, getContent } from '@/lib';
import type { MarginY } from '../../Form/StyledComponents';
import { Section } from '../../Form/StyledComponents';
import { SectionHeading } from '@/components/Headings';
import { LegalAgeDisclosure } from './LegalAgeDisclosure';
import { formInputHandlers } from '@/components/Form/formInputHandlers';
interface ContactFieldsSectionProps {
  fieldOrder?: string[];
  isStreamlineExperience?: boolean;
  mb?: MarginY;
  position?: string;
  showHeading?: boolean;
}

export const ContactFieldsSection = ({
  showHeading = true,
  fieldOrder = ['name', 'phone', 'email'],
  isStreamlineExperience = false,
  position,
  mb,
}: ContactFieldsSectionProps): React.ReactElement | null => {
  const shouldNotRender = !shouldRenderFields(position);

  if (shouldNotRender) {
    return null;
  }

  /**
   * The users name is required for all flows and we normally collect it with
   * the billing address fields. In flows where we are not collecting the
   * address we collect the name alongside the contact information fields.
   */
  const isAddressless = features.isActive('isAddressless');

  const fieldLookup: {
    [key: string]: ((props: any) => React.ReactElement) | null;
  } = {
    email: Email,
    name: isAddressless ? Name : null,
    phone: PhoneNumber,
  };

  const activeSCAPhoneConfirmation = features.isActive(
    'shouldShowSCAPhoneConfirmation',
  );
  return (
    <Section data-testid="contactFieldsSection" mb={mb}>
      {showHeading && (
        <SectionHeading>
          {getContent('billing.contactInformation')}
        </SectionHeading>
      )}

      {fieldOrder.map(key => {
        const Field = fieldLookup[key];
        if (!Field) {
          return null;
        }
        return (
          <Field
            isStreamlineExperience={isStreamlineExperience}
            key={key}
            {...formInputHandlers}
          />
        );
      })}
      {!activeSCAPhoneConfirmation && <LegalAgeDisclosure />}
    </Section>
  );
};
